/**
 * Список регионов РФ с кодами для автотранспорта
 * Для регионов с несколькими кодами используется первый код
 */
export interface Region {
  code: number;
  name: string;
  allCodes: number[];
}

export const RUSSIAN_REGIONS: Region[] = [
  { code: 1, name: 'Республика Адыгея', allCodes: [1, 101] },
  { code: 2, name: 'Республика Башкортостан', allCodes: [2, 102, 702] },
  { code: 3, name: 'Республика Бурятия', allCodes: [3, 103] },
  { code: 4, name: 'Республика Алтай', allCodes: [4] },
  { code: 5, name: 'Республика Дагестан', allCodes: [5, 105] },
  { code: 6, name: 'Республика Ингушетия', allCodes: [6] },
  { code: 7, name: 'Кабардино-Балкарская Республика', allCodes: [7] },
  { code: 8, name: 'Республика Калмыкия', allCodes: [8] },
  { code: 9, name: 'Карачаево-Черкесская Республика', allCodes: [9, 109] },
  { code: 10, name: 'Республика Карелия', allCodes: [10] },
  { code: 11, name: 'Республика Коми (Сыктывкар)', allCodes: [11, 111] },
  { code: 12, name: 'Республика Марий Эл', allCodes: [12] },
  { code: 13, name: 'Республика Мордовия', allCodes: [13, 113] },
  { code: 14, name: 'Республика Саха (Якутия)', allCodes: [14] },
  { code: 15, name: 'Республика Северная Осетия — Алания', allCodes: [15, 115] },
  { code: 16, name: 'Республика Татарстан', allCodes: [16, 116, 716] },
  { code: 17, name: 'Республика Тыва', allCodes: [17] },
  { code: 18, name: 'Удмуртская Республика', allCodes: [18, 118] },
  { code: 19, name: 'Республика Хакасия', allCodes: [19] },
  { code: 20, name: 'Чеченская Республика', allCodes: [20, 95] },
  { code: 21, name: 'Чувашская Республика (Чувашия)', allCodes: [21, 121] },
  { code: 22, name: 'Алтайский край', allCodes: [22, 122] },
  { code: 23, name: 'Краснодарский край', allCodes: [23, 93, 123, 193, 323] },
  { code: 24, name: 'Красноярский край', allCodes: [24, 84, 88, 124] },
  { code: 25, name: 'Приморский край', allCodes: [25, 125, 725] },
  { code: 26, name: 'Ставропольский край', allCodes: [26, 126] },
  { code: 27, name: 'Хабаровский край', allCodes: [27, 127] },
  { code: 28, name: 'Амурская область', allCodes: [28] },
  { code: 29, name: 'Архангельская область', allCodes: [29] },
  { code: 30, name: 'Астраханская область', allCodes: [30, 130] },
  { code: 31, name: 'Белгородская область', allCodes: [31, 131] },
  { code: 32, name: 'Брянская область', allCodes: [32] },
  { code: 33, name: 'Владимирская область', allCodes: [33] },
  { code: 34, name: 'Волгоградская область', allCodes: [34, 134] },
  { code: 35, name: 'Вологодская область', allCodes: [35] },
  { code: 36, name: 'Воронежская область', allCodes: [36, 136] },
  { code: 37, name: 'Ивановская область', allCodes: [37] },
  { code: 38, name: 'Иркутская область', allCodes: [38, 138] },
  { code: 39, name: 'Калининградская область', allCodes: [39, 91, 139] },
  { code: 40, name: 'Калужская область', allCodes: [40] },
  { code: 41, name: 'Камчатский край', allCodes: [41] },
  { code: 42, name: 'Кемеровская область (Кузбасс)', allCodes: [42, 142] },
  { code: 43, name: 'Кировская область', allCodes: [43] },
  { code: 44, name: 'Костромская область', allCodes: [44] },
  { code: 45, name: 'Курганская область', allCodes: [45] },
  { code: 46, name: 'Курская область', allCodes: [46] },
  { code: 47, name: 'Ленинградская область', allCodes: [47, 147] },
  { code: 48, name: 'Липецкая область', allCodes: [48] },
  { code: 49, name: 'Магаданская область', allCodes: [49] },
  { code: 50, name: 'Московская область', allCodes: [50, 90, 150, 190, 250, 550, 750, 790] },
  { code: 51, name: 'Мурманская область', allCodes: [51] },
  { code: 52, name: 'Нижегородская область', allCodes: [52, 152, 252] },
  { code: 53, name: 'Новгородская область', allCodes: [53] },
  { code: 54, name: 'Новосибирская область', allCodes: [54, 154, 754] },
  { code: 55, name: 'Омская область', allCodes: [55, 155] },
  { code: 56, name: 'Оренбургская область', allCodes: [56, 156] },
  { code: 57, name: 'Орловская область', allCodes: [57] },
  { code: 58, name: 'Пензенская область', allCodes: [58, 158] },
  { code: 59, name: 'Пермский край', allCodes: [59, 159] },
  { code: 60, name: 'Псковская область', allCodes: [60] },
  { code: 61, name: 'Ростовская область', allCodes: [61, 161, 761] },
  { code: 62, name: 'Рязанская область', allCodes: [62] },
  { code: 63, name: 'Самарская область', allCodes: [63, 163, 763] },
  { code: 64, name: 'Саратовская область', allCodes: [64, 164] },
  { code: 65, name: 'Сахалинская область', allCodes: [65] },
  { code: 66, name: 'Свердловская область (Екатеринбург)', allCodes: [66, 96, 196] },
  { code: 67, name: 'Смоленская область', allCodes: [67] },
  { code: 68, name: 'Тамбовская область', allCodes: [68] },
  { code: 69, name: 'Тверская область', allCodes: [69, 169] },
  { code: 70, name: 'Томская область', allCodes: [70] },
  { code: 71, name: 'Тульская область', allCodes: [71] },
  { code: 72, name: 'Тюменская область', allCodes: [72, 172] },
  { code: 73, name: 'Ульяновская область', allCodes: [73, 173] },
  { code: 74, name: 'Челябинская область', allCodes: [74, 174, 774] },
  { code: 75, name: 'Забайкальский край', allCodes: [75] },
  { code: 76, name: 'Ярославская область', allCodes: [76] },
  { code: 77, name: 'Москва', allCodes: [77, 97, 99, 177, 197, 199, 777, 797, 799, 977] },
  { code: 78, name: 'Санкт-Петербург', allCodes: [78, 98, 178, 198] },
  { code: 79, name: 'Еврейская автономная область', allCodes: [79] },
  { code: 80, name: 'Донецкая Народная Республика (ДНР)', allCodes: [80, 180] },
  { code: 81, name: 'Луганская Народная Республика (ЛНР)', allCodes: [81, 181] },
  { code: 82, name: 'Республика Крым', allCodes: [82, 182] },
  { code: 83, name: 'Ненецкий автономный округ', allCodes: [83] },
  { code: 84, name: 'Херсонская область', allCodes: [84, 184] },
  { code: 85, name: 'Запорожская область', allCodes: [85, 185] },
  { code: 86, name: 'Ханты-Мансийский автономный округ (Югра)', allCodes: [86, 186] },
  { code: 87, name: 'Чукотский автономный округ', allCodes: [87] },
  { code: 89, name: 'Ямало-Ненецкий автономный округ', allCodes: [89] },
  { code: 92, name: 'Севастополь', allCodes: [92, 192] },
  { code: 94, name: 'Зарубежные территории, обслуживаемые МВД РФ, Байконур', allCodes: [94] },
  { code: 188, name: 'Харьковская область', allCodes: [188] },
];

/**
 * Найти регион по коду
 */
export function findRegionByCode(code: number): Region | undefined {
  return RUSSIAN_REGIONS.find(r => r.code === code);
}

/**
 * Получить название региона по коду
 */
export function getRegionName(code: number): string {
  const region = findRegionByCode(code);
  return region ? region.name : `Регион ${code}`;
}

